import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import './ToastNotification.css';

const containsHtml = (message) => {
    return /<[a-z][\s\S]*>/i.test(message || '');
};

export const renderNotificationMessage = (message, onLinkClick) => {
    if (!message) {
        return null;
    }

    if (!containsHtml(message)) {
        return message;
    }

    const cleanHtml = DOMPurify.sanitize(message, {
        ALLOWED_TAGS: ['a', 'br', 'b', 'strong'],
        ALLOWED_ATTR: ['href', 'target', 'rel']
    });

    return (
        <span
            className="notification-message"
            onClick={onLinkClick}
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
    );
};

export const ToastNotification = ({ message, type, onClose }) => {
    useEffect(() => {
        if (!message) {
            return;
        }

        const hasHtml = containsHtml(message);

        const delay = hasHtml ? 8000 : 3000;

        const timer = setTimeout(() => {
            onClose();
        }, delay);

        return () => clearTimeout(timer);
    }, [message, onClose]);

    if (!message) {
        return null;
    }

    const icons = {
        success: 'check-circle',
        error: 'exclamation-circle',
        warning: 'exclamation-triangle',
        info: 'info-circle'
    };

    const iconName = icons[type] || icons.info;

    return (
        <div className={`notification ${type}`}>
            <div className="d-flex align-items-center">
                <i className={`fas fa-${iconName} notification-icon`}></i>

                <span>
                    {renderNotificationMessage(message)}
                </span>
            </div>

            <button
                className="notification-close"
                onClick={onClose}
                aria-label="Закрыть"
                draggable="false"
            >
                &times;
            </button>
        </div>
    );
};